var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BFileUpload',_vm._b({attrs:{"value":_vm.value,"upload-file":_vm.uploadFile},on:{"input":function($event){return _vm.$emit('input', $event)}}},'BFileUpload',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }